import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getRequestCategoryThunk } from 'redux/Reducers/Concierge/requestCategorySlicer';
import { getSubCategoryBillPaymentThunk } from 'redux/Reducers/Concierge/getSubCategoryBillPaymentSlicer';
import { getRequestSubcategoryFormThunk } from 'redux/Reducers/Concierge/requestSubcategoryFormSlicer';
import { resetConvertedPointsData } from 'redux/Reducers/Concierge/getConvertedPointsSlice';

import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';

import { Col, notification, Row } from 'antd';
import { Form, Typography, VertButton, VertLoading, VertSelect } from '@vertem-core/vertice-ds';

import FormInformationProduct from './FormInformationProduct';
import FormInformationBillPayment from './FormInformationBillPayment';

import PropTypes from 'prop-types';

import { CategoryTypeEnum } from 'pages/ManageConciergeSolicitationPage/enum/action-enum';
import { SolicitationItemInitialState } from 'Constants/Concierge/initialStateValues';

const FormInformation = ({ ...props }) => {
    const {
        solicitation,
        setSolicitation,
        userPoints,
        setShowForm,
        form,
        currentProductService,
        setCurrentProductService,
        isEditingProductService,
        setIsEditingProductService,
        editingProductServiceTotalPoints,
        subCategoryList,
        setSubCategoryList,
        handlePreviousStep,
    } = props;

    const [categoryList, setCategoryList] = useState([]);
    const [subCategorySelected, setSubCategorySelected] = useState({});
    const [subcategoryFields, setSubcategoryFields] = useState([]);
    const [subcategoryDisclaimers, setSubcategoryDisclaimers] = useState([]);

    const dispatch = useDispatch();

    const {
        loadingGetSubCategoryBillPayment
    } = useSelector(
        (state) => state.GetSubCategoryBillPayment
    );

    const {
        loadingRequestCategory,
        errorRequestCategory
    } = useSelector(
        (state) => state.RequestCategory
    );

    const {
        dataRequestSubcategoryForm,
        loadingRequestSubcategoryForm,
        errorRequestSubcategoryForm
    } = useSelector(
        (state) => state.RequestSubcategoryForm
    );

    const resetForm = () => {
        form.resetFields();
        setCurrentProductService(SolicitationItemInitialState);
        setIsEditingProductService(false);
    }

    const subCategoryLabel = solicitation.type == CategoryTypeEnum.BillPayment ? "Tipo de conta" : "Subcategoria";

    const handleKeyDown = (event) => {
        if (event.key === 'Enter')
            event.preventDefault();
    };

    const handlerCategorySelected = (value) => {
        const selectedCategory = categoryList.find(category => category.value === value);

        form.resetFields([
            'date',
            'barCode',
            'quantity',
            'description',
            'pointsValue',
            'unitValue',
            'agreedTerms',
            'title',
            'pointsTotalValue'
        ]);

        categoryList.subcategories = selectedCategory.subcategories;

        const subcategories = selectedCategory.subcategories.map(subcategory => ({
            value: subcategory.id,
            label: subcategory.name,
            name: subcategory.name
        }));

        setSubCategoryList(subcategories);

        const subcategory = subcategories?.length == 1 ? subcategories[0] : null;

        if (subcategory) {
            dispatch(resetConvertedPointsData());
            dispatch(getRequestSubcategoryFormThunk(subcategory.value));
        }

        setCurrentProductService((prevState) => ({
            ...prevState,
            category: value,
            categoryLabel: selectedCategory.label,
            subCategory: subcategory?.value,
            subCategoryLabel: subcategory?.label
        }))

        form.setFieldValue('subCategory', subcategory?.value);
    }

    const handleSelectedSubcategory = (value) => {
        const selectedSubcategory = subCategoryList.find(subCategory => subCategory.value === value);

        setCurrentProductService((prevState) => ({
            ...prevState,
            subCategory: value,
            subCategoryLabel: selectedSubcategory.label,
            barCode: '',
        }));

        if (solicitation.isBillPayment) {
            setSubCategorySelected(selectedSubcategory.subcategory);
            form.setFieldValue("barCode", "");
        }

        form.resetFields([
            'date',
            'barCode',
            'quantity',
            'description',
            'pointsValue',
            'unitValue',
            'agreedTerms',
            'title',
            'pointsTotalValue'
        ]);

        dispatch(resetConvertedPointsData());
        dispatch(getRequestSubcategoryFormThunk(selectedSubcategory.value));
    }

    useEffect(() => {
        if (!categoryList?.length) return;

        if (categoryList.length == 1 && !currentProductService.category) {
            const category = categoryList[0];
            handlerCategorySelected(category.value);
            form.setFieldValue("category", category.value);
        }
    }, [categoryList]);

    useEffect(() => {
        if (!dataRequestSubcategoryForm) return;

        const { disclaimers, fields } = dataRequestSubcategoryForm;

        setSubcategoryFields(fields || []);
        setSubcategoryDisclaimers(disclaimers || []);

    }, [dataRequestSubcategoryForm]);

    useEffect(() => {
        if (!errorRequestSubcategoryForm) return;

        notification.error({
            message: 'Não foi possível carregar o formulário'
        });

    }, [errorRequestSubcategoryForm]);

    useEffect(() => {
        if (solicitation.type == CategoryTypeEnum.Product) {
            dispatch(getRequestCategoryThunk(solicitation.requestTypeFlowId)).then((res) => {
                const { payload } = res;

                const categories = payload.reduce((acc, category) => {
                    const formattedCategory = {
                        label: category.name,
                        name: category.name,
                        value: category.id,
                        type: category.type,
                        subcategories: [...category.subcategories],
                    };

                    acc.push(formattedCategory);

                    return acc;
                }, []);

                setCategoryList(categories);
            });

            return;
        }

        dispatch(getSubCategoryBillPaymentThunk()).then((res) => {
            const { payload } = res;

            setSubCategoryList(payload.map(subcategory => ({
                name: subcategory.name,
                label: subcategory.name,
                value: subcategory.serviceId,
                subcategory: subcategory,
            })))
        });

        setSolicitation({
            ...solicitation,
            haveFavoriteSupplier: null,
            supplierId: null,
            receiveBudget: null,
            supplierLabel: null,
            deliveryAddress: null,
        });

        setCurrentProductService({
            ...currentProductService,
            categoryLabel: "Pagamento de conta",
        });
    }, []);

    return (
        <>
            <Form
                className='form-new-solicitation'
                form={form}
                onKeyDown={handleKeyDown}
            >
                {!errorRequestCategory &&
                    <>
                        {loadingRequestCategory ?
                            <VertLoading className='loading-space' />
                            :
                            <div className='container-concierge-information-main'>
                                <Typography.Text className='text-subtitle'>
                                    {
                                        solicitation.type === CategoryTypeEnum.BillPayment
                                            ? "Escolha o tipo de conta que deseja pagar:"
                                            : "Escolha a categoria e a subcategoria do produto/serviço que deseja solicitar:"
                                    }
                                </Typography.Text>

                                <Row gutter={8} className='container-category-sub-category'>
                                    {
                                        solicitation.type == CategoryTypeEnum.Product && (
                                            <Col xs={24} sm={10} md={10} lg={10} xl={10}>
                                                <Form.Item
                                                    name="category"
                                                >
                                                    <VertSelect
                                                        className='select-category'
                                                        key={'category'}
                                                        label='Selecionar Categoria'
                                                        placeholder='Selecionar Categoria'
                                                        onChange={(val) => handlerCategorySelected(val)}
                                                        options={categoryList}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        )
                                    }

                                    <Col xs={24} sm={10} md={10} lg={10} xl={10}>
                                        <Form.Item
                                            name="subCategory"
                                        >
                                            <VertSelect
                                                disabled={solicitation.type === CategoryTypeEnum.Product && !currentProductService.category}
                                                className='select-category'
                                                key={'subCategory'}
                                                label={'Selecionar ' + subCategoryLabel}
                                                placeholder={'Selecionar ' + subCategoryLabel}
                                                loading={loadingGetSubCategoryBillPayment}
                                                onChange={(val) => handleSelectedSubcategory(val)}
                                                items={subCategoryList}
                                            />
                                        </Form.Item>
                                    </Col>

                                    {
                                        (!isEditingProductService && solicitation.productList?.length > 0 && !currentProductService.subCategory) &&
                                        <Col span={24}>
                                            <VertButton
                                                type='default'
                                                size="default"
                                                htmlType="button"
                                                className='button-concierge'
                                                onClick={() => {
                                                    resetForm();
                                                    setShowForm(false);
                                                }}
                                            >
                                                <Typography.Text className='span-button'>
                                                    Cancelar
                                                </Typography.Text>
                                            </VertButton>
                                        </Col>
                                    }
                                </Row>
                                {
                                    loadingRequestSubcategoryForm
                                        ? <VertLoading className='loading-space' />
                                        : solicitation.isBillPayment ? (
                                            currentProductService.subCategory &&
                                            <FormInformationBillPayment
                                                solicitation={solicitation}
                                                setSolicitation={setSolicitation}
                                                userPoints={userPoints}
                                                setShowForm={setShowForm}
                                                form={form}
                                                currentProductService={currentProductService}
                                                setCurrentProductService={setCurrentProductService}
                                                isEditingProductService={isEditingProductService}
                                                setIsEditingProductService={setIsEditingProductService}
                                                editingProductServiceTotalPoints={editingProductServiceTotalPoints}
                                                subCategoryList={subCategoryList}
                                                subCategorySelected={subCategorySelected}
                                            />
                                        ) : (
                                            (currentProductService.category && currentProductService.subCategory) &&
                                            <FormInformationProduct
                                                solicitation={solicitation}
                                                setSolicitation={setSolicitation}
                                                userPoints={userPoints}
                                                setShowForm={setShowForm}
                                                form={form}
                                                currentProductService={currentProductService}
                                                setCurrentProductService={setCurrentProductService}
                                                isEditingProductService={isEditingProductService}
                                                setIsEditingProductService={setIsEditingProductService}
                                                editingProductServiceTotalPoints={editingProductServiceTotalPoints}
                                                handlePreviousStep={handlePreviousStep}
                                                subcategoryFields={subcategoryFields}
                                                subcategoryDisclaimers={subcategoryDisclaimers}
                                            />
                                        )
                                }
                            </div>
                        }
                    </>
                }
            </Form>
        </>
    )
}

FormInformation.propTypes = {
    solicitation: PropTypes.object.isRequired,
    setSolicitation: PropTypes.func.isRequired,
    setShowForm: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    currentProductService: PropTypes.object.isRequired,
    setCurrentProductService: PropTypes.func.isRequired,
    isEditingProductService: PropTypes.bool.isRequired,
    setIsEditingProductService: PropTypes.func.isRequired,
    editingProductServiceTotalPoints: PropTypes.number.isRequired,
    userPoints: PropTypes.number.isRequired,
    subCategoryList: PropTypes.array.isRequired,
    setSubCategoryList: PropTypes.func.isRequired,
    handlePreviousStep: PropTypes.func.isRequired,
};

export default FormInformation;
